import React, { Component } from 'react'
import {
  FormBox, FAIcon, WizardBox, WizardBoxItem, NumberBox, Label,
  WizardBoxSteps, TextBox, FieldLayoutSizes, PasswordBox,
  ViewBox, ComboBox, RadioListBox, Button, Row, Col, MultiSelectComboBox
} from 'common-controls/Core/index'
import styles from './SignUp.less'
import { ah, sh, compose, ReduxWrapper, QueryWrapper } from 'common-data/datahelpers'
import { BuildMessageBusEvents, log } from 'common-tools/index'
import _ from 'common-tools/LodashHelper'

export const SignUpEvents = BuildMessageBusEvents('Login.SignUp')

const formName = 'SignUp'
const stopAction = true
const allowAction = false

let executedAgreements = []

class SignUpPlain extends Component {
  constructor (props) {
    super(props)

    this.state = {
      initialValues: {},
      SignUpSteps: {
        Email: 'email',
        ConfirmEmail: 'confirmEmail',
        Phone: 'phone',
        ConfirmPhone: 'confirmPhone',
        Details: 'addDetails',
        Confirm: 'confirm',
        Password: 'password'
      },
      SignUpCompletedSteps: [],
      isPasswordValid: false
    }
  }

  componentDidMount () {
    const { clearUser, SessionDeviceFingerPrint, formSetFieldValue, GetCurrentRevisionsAgreementTemplates } = this.props

    formSetFieldValue(formName, 'DeviceFingerPrint', SessionDeviceFingerPrint)

    // GetLookups({
    //   Names: ['Languages']
    // })

    GetCurrentRevisionsAgreementTemplates()
      .then(({ data }) => {
        const agreementSteps = _.map(data, (agreement) => {
          return `Agreement_${agreement._key}`
        })
        this.setState({ SignUpSteps: _.merge(this.state.SignUpSteps, { Agreements: agreementSteps }) })
      })

    try {
      clearUser()
    } catch (err) {
      log.Error('Failed Clear Agency User', { Error: err })
    }
  }

  onSubmit (values) {
    const { formCheckForSubmissionErrors, AccountAdd, showSuccess, close,
      AccountLogin, formDataSignUp, setAccount, sendToURL } = this.props
    return AccountAdd(values)
      .then(({ data }) => {
        showSuccess(`Congratulations!!! Your account have been created. Check your email for more details.`)
        AccountLogin({
          LoginId: formDataSignUp.Username,
          Password: formDataSignUp.Password,
          IsOAuth: false,
          DeviceFingerPrint: values.DeviceFingerPrint.Id,
          DeviceUserAgent: values.DeviceFingerPrint.UserAgent
        })
          .then(({ data, extra }) => {
            setAccount(extra.Token, data)
            close([{ Type: SignUpEvents.Close }, { Type: SignUpEvents.Success }])
            sendToURL('/App')
          }).catch(formCheckForSubmissionErrors)
      })
      .catch(formCheckForSubmissionErrors)
  }

  async beforeStepAction (nextStep, previousStep, direction) {
    const { close, formDataSignUp,
      ValidateEmail, ValidateEmailCode, formCheckForSubmissionErrors, ValidateUsername,
      ValidatePhone, ValidatePhoneCode, showInfo, formSetFieldValue, data, formSetValidation } = this.props
    const { SignUpSteps, SignUpCompletedSteps, isPasswordValid } = this.state

    switch (nextStep) {
      case WizardBoxSteps.Done:
        return allowAction
      case WizardBoxSteps.Cancel:
        close([{ Type: SignUpEvents.Close }])
        return allowAction
    }

    if (direction === 'previous') {
      return allowAction
    }

    if (direction === 'next' && _.includes(SignUpCompletedSteps, previousStep)) {
      return allowAction
    }

    let errors = {}

    switch (previousStep) {
      case SignUpSteps.Email:
        if (!formDataSignUp.Email) {
          if (nextStep !== WizardBoxSteps.Cancel) {
            errors.Email = 'You must enter a valid email'
            formSetValidation(formName, errors)
            return stopAction
          }
        } else {
          try {
            await ValidateEmail({ Email: formDataSignUp.Email })
          } catch (err) {
            const ret = formCheckForSubmissionErrors(err, false) || {}
            formSetValidation(formName, ret.data || ret, ret.fields)
            return stopAction
          }
        }
        this.setState({
          SignUpCompletedSteps: _.uniq(_.concat(SignUpCompletedSteps, previousStep))
        })
        return allowAction

      case SignUpSteps.ConfirmEmail:
        if (!formDataSignUp.ConfirmEmailCode) {
          errors.ConfirmEmailCode = 'Type a valid code'
          formSetValidation(formName, errors)
          return stopAction
        } else {
          try {
            await ValidateEmailCode({
              Email: formDataSignUp.Email,
              EmailVerificationCode: formDataSignUp.ConfirmEmailCode
            })
          } catch (err) {
            const ret = formCheckForSubmissionErrors(err, false) || {}
            formSetValidation(formName, ret.data || ret, ret.fields)
            return stopAction
          }
        }
        this.setState({
          SignUpCompletedSteps: _.uniq(_.concat(SignUpCompletedSteps, previousStep))
        })
        return allowAction

      case SignUpSteps.Phone:
        if (!formDataSignUp.Phone) {
          errors.Phone = 'Please enter a valid phone number'
          formSetValidation(formName, errors)
          return stopAction
        } else {
          try {
            await ValidatePhone({ Email: formDataSignUp.Email, Phone: formDataSignUp.Phone })
          } catch (err) {
            const ret = formCheckForSubmissionErrors(err, false) || {}
            formSetValidation(formName, ret.data || ret, ret.fields)
            return stopAction
          }
        }
        this.setState({
          SignUpCompletedSteps: _.uniq(_.concat(SignUpCompletedSteps, previousStep))
        })
        return allowAction

      case SignUpSteps.ConfirmPhone:
        if (!formDataSignUp.ConfirmPhoneCode) {
          errors.ConfirmPhoneCode = 'Type a valid code'
          formSetValidation(formName, errors)
          return stopAction
        } else {
          try {
            await ValidatePhoneCode({
              Email: formDataSignUp.Email,
              Phone: formDataSignUp.Phone,
              PhoneVerificationCode: formDataSignUp.ConfirmPhoneCode
            })
          } catch (err) {
            const ret = formCheckForSubmissionErrors(err, false) || {}
            formSetValidation(formName, ret.data || ret, ret.fields)
            return stopAction
          }
        }
        this.setState({
          SignUpCompletedSteps: _.uniq(_.concat(SignUpCompletedSteps, previousStep))
        })
        return allowAction

      case SignUpSteps.Details:
        if (!formDataSignUp.Username) {
          errors.Username = 'Field cannot be empty'
          formSetValidation(formName, errors)
          return stopAction
        } else {
          try {
            await ValidateUsername({ Username: formDataSignUp.Username })
          } catch (err) {
            const ret = formCheckForSubmissionErrors(err, false) || {}
            formSetValidation(formName, ret.data || ret, ret.fields)
            return stopAction
          }
        }
        if (!formDataSignUp.FirstName) {
          errors.FirstName = 'Field cannot be empty'
        }

        if (!formDataSignUp.LastName) {
          errors.LastName = 'Field cannot be empty'
        }

        if (!formDataSignUp.Gender) {
          errors.Gender = 'Field cannot be empty'
        }

        if (!_.isEmpty(errors)) {
          formSetValidation(formName, errors)
          return stopAction
        }
        this.setState({
          SignUpCompletedSteps: _.uniq(_.concat(SignUpCompletedSteps, previousStep))
        })
        return allowAction

      case SignUpSteps.Password:

        if (!formDataSignUp.Password) {
          errors.Password = 'Password cannot be empty'
        } else if (!formDataSignUp.PasswordConfirm) {
          errors.PasswordConfirm = 'Password confirmation cannot be empty'
        } else if (formDataSignUp.Password !== formDataSignUp.PasswordConfirm) {
          errors.Password = 'Password must match Password Confirmation'
          errors.PasswordConfirm = 'Password Confirmation must match Password'
        }

        if (!isPasswordValid) {
          errors.Password = 'Password does not pass the Validation Rules.'
        }

        if (formDataSignUp.Password.toLowerCase().includes(formDataSignUp.FirstName.toLowerCase()) ||
        formDataSignUp.Password.toLowerCase().includes(formDataSignUp.LastName.toLowerCase())) {
          errors.Password = 'Password cannot contain either the first name last name , please choose another password.'
        }

        let loginIds = [_.toLower(formDataSignUp.Username), formDataSignUp.Phone.toString(), _.toLower(formDataSignUp.Email)]
        let containsLoginId = _.find(loginIds, (l) => {
          return l.toLowerCase().includes(formDataSignUp.Password.toLowerCase())
        })

        if (containsLoginId) {
          errors.Password = 'Password cannot contain login ids(username, email, phone) , please choose another password.'
          return
        }

        if (!_.isEmpty(errors)) {
          formSetValidation(formName, errors)
          return stopAction
        }
        this.setState({
          SignUpCompletedSteps: _.uniq(_.concat(SignUpCompletedSteps, previousStep))
        })
        return allowAction

      default:
        if (previousStep.indexOf('Agreement_') > -1) {
          const agreementKey = _.split(previousStep, '_')[1]

          const agreement = _.filter(data.GetCurrentRevisionsAgreementTemplatesResults, (item) => {
            return item._key === agreementKey
          })

          if (formDataSignUp[`${previousStep}_Option`] !== 'I Agree') {
            showInfo(`You'll need to agree to the ${agreement[0].Title} terms and conditions`)
            errors[previousStep] = ` `
          } else {
            let itemExist = _.filter(executedAgreements, {
              TemplateKey: agreement[0]._key,
              VersionId: agreement[0].CurrentVersion.Id
            })

            if (itemExist.length === 0) {
              executedAgreements.push(
                {
                  TemplateKey: agreement[0]._key,
                  VersionId: agreement[0].CurrentVersion.Id
                })
            }

            formSetFieldValue(formName, 'Location', 'Houston Texas')
            formSetFieldValue(formName, 'Confirmed', true)
            formSetFieldValue(formName, 'ConfirmOTP', 'ABC1024')
            formSetFieldValue(formName, 'IsTemporary', false)
            formSetFieldValue(formName, 'ExecutedAgreements', executedAgreements)
            this.setState({
              SignUpCompletedSteps: _.uniq(_.concat(SignUpCompletedSteps, previousStep))
            })
            return allowAction
          }

          formSetValidation(formName, errors)
          return stopAction
        }
    }

    throw new Error(`Unexpected pervious step named ${previousStep}`)
  }

  afterStepAction (nextStep, previousStep, direction) {
  }

  setIsPasswordValid = (valid) => {
    this.setState({ isPasswordValid: valid })
  }

  renderEmail (readonly) {
    return (
      <React.Fragment>
        <span className={styles.tabTitle}>
          <h1>{`Let's get started! `}<FAIcon name='smile' color='primary' /></h1>
        </span>
        <Row className={'align-center'}>
          <h2>What email are you going to be using?</h2>
        </Row>
        <Row>
          <TextBox readonly={readonly} layout={FieldLayoutSizes.Middle} name="Email" placeHolder="Type Email Address Here" autoComplete="email" />
        </Row>
      </React.Fragment>
    )
  }

  renderConfirmEmail (readonly) {
    return (
      <React.Fragment>
        <span className={styles.tabTitle}>
          <h1>Confirm your email</h1>
        </span>
        <Row className={'align-center'}>
          <h2>Please check your email for a new message that contains your confirmation code.</h2>
        </Row>
        <Row>
          <TextBox readonly={readonly} layout={FieldLayoutSizes.Middle} name="ConfirmEmailCode" placeHolder="Type Confirmation Code Here" autoComplete="email" />
        </Row>
      </React.Fragment>
    )
  }

  renderPhone (readonly) {
    return (
      <React.Fragment>
        <span className={styles.tabTitle}>
          <h1>What is your primary cell phone number?</h1>
        </span>
        <Row className={'align-center'}>
          <h2>For extra security we are going to send you a text with another confirmation code.</h2>
        </Row>
        <Row>
          <NumberBox readonly={readonly} type={NumberBox.FormatTypes.Phone} layout={FieldLayoutSizes.Middle} name="Phone" placeHolder="Type Cell Phone Number Here" autoComplete="phone" />
        </Row>
      </React.Fragment>
    )
  }

  renderConfirmPhone (readonly) {
    return (
      <React.Fragment>
        <span className={styles.tabTitle}>
          <h1>Confirm your cell phone number</h1>
        </span>
        <Row className={'align-center'}>
          <h2>Please check your cell phone for a new message that contains your second confirmation code.</h2>
        </Row>
        <Row>
          <TextBox readonly={readonly} layout={FieldLayoutSizes.Middle} name="ConfirmPhoneCode" placeHolder="Type Cell Phone Confirmation Code Here" />
        </Row>
      </React.Fragment>
    )
  }

  renderDetails (readonly, { Lookups = {} }) {
    return (
      <React.Fragment>
        <span className={styles.tabTitle}>
          <h1>{`All confirmed!  Let's get your details`}<FAIcon name='smile' color='primary' /></h1>
        </span>
        <Row className={'align-center'}>
          <h2>Fill out the questions below.</h2>
        </Row>
        <Row>
          <TextBox readonly={readonly} layout={FieldLayoutSizes.Middle} name="Username" caption='Something short and sweet' placeHolder="Username" />
        </Row>
        <Row>
          <TextBox readonly={readonly} layout={FieldLayoutSizes.Middle} name="FirstName" placeHolder="Type First Name Here" caption='Your legal first name' />
        </Row>
        <Row>
          <TextBox readonly={readonly} layout={FieldLayoutSizes.Middle} name="LastName" placeHolder="Type Last Name Here" caption='Your legal last name' />
        </Row>
        <Row>
          <ComboBox
            layout={FieldLayoutSizes.Middle} name="Gender"
            options={[
              { Text: 'Choose Gender', Value: '' },
              { Text: 'Female', Value: 'Female' },
              { Text: 'Male', Value: 'Male' }
            ]}
            autosetFirstOption
          />
        </Row>
        <Row>
          <MultiSelectComboBox
            layout={FieldLayoutSizes.Middle} name="Languages"
            options={[
              { Text: 'Choose Spoken Languages', Value: '' },
              { Text: 'Arabic', Value: 'Arabic' },
              { Text: 'Chinese', Value: 'Chinese' },
              { Text: 'English', Value: 'English' },
              { Text: 'Igbo', Value: 'Igbo' },
              { Text: 'Korean', Value: 'Korean' },
              { Text: 'Mandarin', Value: 'Mandarin' },
              { Text: 'Russian', Value: 'Russian' },
              { Text: 'Spanish', Value: 'Spanish' },
              { Text: 'Vietnamese', Value: 'Vietnamese' },
              { Text: 'Yoruba', Value: 'Yoruba' }
            ]}
            autosetFirstOption
            label={`Spoken Languages`}
          />
        </Row>

      </React.Fragment>
    )
  }

  renderPassword (readonly) {
    return (
      <React.Fragment>
        <span className={styles.tabTitle}>
          <h1>Almost done</h1>
        </span>
        <Row className={'align-center'}>
          <h2>Just need to set a password.</h2>
        </Row>
        <Row>
          <PasswordBox readonly={readonly} layout={FieldLayoutSizes.Middle} type="password" name="Password" placeHolder="Type Password Here" isValid={this.setIsPasswordValid}/>
        </Row>
        <Row>
          <TextBox readonly={readonly} layout={FieldLayoutSizes.Middle} type="password" name="PasswordConfirm" placeHolder="Retype Password Here" />
        </Row>
      </React.Fragment>
    )
  }

  renderConfirmationPage (formSubmit, loading) {
    return (
      <React.Fragment>
        <h1>Finally, the last step</h1>
        <h2>{`Ok, let's review your information before we save it all.`}</h2>
        <div className={styles.confirmContainer}>
          <div className={styles.confirmContainerContent}>
            <Label>Email</Label>
            <ViewBox name="Email" />
            <FAIcon name='check-circle' color='primary' />
          </div>
          <div className={styles.confirmContainerContent}>
            <Label>Username</Label>
            <ViewBox name="Username" />
            <FAIcon name='check-circle' color='primary' />
          </div>
          <div className={styles.confirmContainerContent}>
            <Label>Phone Number</Label>
            <ViewBox name="Phone" />
            <FAIcon name='check-circle' color='primary' />
          </div>
          <div className={styles.confirmContainerContent}>
            <Label>First Name</Label>
            <ViewBox name="FirstName" />
            <FAIcon name='check-circle' color='primary' />
          </div>
          <div className={styles.confirmContainerContent}>
            <Label>Last Name</Label>
            <ViewBox name="LastName" />
            <FAIcon name='check-circle' color='primary' />
          </div>
          <div className={styles.confirmContainerContent}>
            <Label>Gender</Label>
            <ViewBox name="Gender" />
            <FAIcon name='check-circle' color='primary' />
          </div>
        </div>
        <Row className={'align-center'}>
          <Col layout={FieldLayoutSizes.Middle}>
            <Button loading={loading} color="primary" size="lg" block onClick={() => { formSubmit(formName) }}>Create My Account</Button>
          </Col>
        </Row>
      </React.Fragment>
    )
  }

  render () {
    const { initialValues, SignUpSteps, SignUpCompletedSteps = [] } = this.state
    const { data = {}, formSubmit } = this.props
    const { loadingAccountAdd = false } = data

    let agreementResults = data.GetCurrentRevisionsAgreementTemplatesResults || []
    let agreementItems = []

    if (SignUpSteps.Agreements && (data.GetCurrentRevisionsAgreementTemplatesResults || []).length > 0) {
      agreementItems.push(
        <WizardBoxItem stepId={SignUpSteps.Email} icon="at" nextStepId={SignUpSteps.ConfirmEmail}>
          {this.renderEmail(_.includes(SignUpCompletedSteps, SignUpSteps.Email))}
        </WizardBoxItem>,
        <WizardBoxItem stepId={SignUpSteps.ConfirmEmail} icon="check-circle" nextStepId={SignUpSteps.Phone} previousStepId={SignUpSteps.Email}>
          {this.renderConfirmEmail(_.includes(SignUpCompletedSteps, SignUpSteps.ConfirmEmail))}
        </WizardBoxItem>,
        <WizardBoxItem stepId={SignUpSteps.Phone} icon="phone" nextStepId={SignUpSteps.ConfirmPhone} previousStepId={SignUpSteps.ConfirmEmail}>
          {this.renderPhone(_.includes(SignUpCompletedSteps, SignUpSteps.Phone))}
        </WizardBoxItem>,
        <WizardBoxItem stepId={SignUpSteps.ConfirmPhone} icon="check-circle" nextStepId={SignUpSteps.Details} previousStepId={SignUpSteps.Phone}>
          {this.renderConfirmPhone(_.includes(SignUpCompletedSteps, SignUpSteps.ConfirmPhone))}
        </WizardBoxItem>,
        <WizardBoxItem stepId={SignUpSteps.Details} icon="user" nextStepId={SignUpSteps.Password} previousStepId={SignUpSteps.ConfirmPhone}>
          {this.renderDetails(_.includes(SignUpCompletedSteps, SignUpSteps.Details), data)}
        </WizardBoxItem>,
        <WizardBoxItem stepId={SignUpSteps.Password} icon="key"
          nextStepId={(SignUpSteps.Agreements || []).length > 0 ? SignUpSteps.Agreements[0] : SignUpSteps.Confirm}
          previousStepId={SignUpSteps.Details}>
          {this.renderPassword(_.includes(SignUpCompletedSteps, SignUpSteps.Password))}
        </WizardBoxItem>
      )

      _.forEach(SignUpSteps.Agreements, (agreement, index) => {
        const isReadOnly = _.includes(SignUpCompletedSteps, SignUpSteps.Agreements[index])
        agreementItems.push(
          <WizardBoxItem stepId={SignUpSteps.Agreements[index]} icon="handshake"
            nextStepId={index + 1 === SignUpSteps.Agreements.length
              ? SignUpSteps.Confirm
              : SignUpSteps.Agreements[index + 1]}
            previousStepId={index === 0
              ? SignUpSteps.Password
              : SignUpSteps.Agreements[index - 1]}>

            <React.Fragment>
              {index === 0
                ? <h1>Hold on, some legal stuff</h1>
                : <h1>And some more legal stuff</h1>
              }
              <div className='card'>
                <div className='card-divider'>
                  <h2>{(agreementResults[index] || {}).Title}</h2>
                </div>
                <div className='card-section'>
                  {`
                    ${((agreementResults[index] || {}).CurrentVersion || {}).Text}
                  `}
                  <div className={styles.agreementOptions}>
                    <Row>
                      <RadioListBox readonly={isReadOnly} inline layout={FieldLayoutSizes.Seven}
                        name={`Agreement_${(agreementResults[index] || {})._key}_Option`}
                        options={[{ Value: 'I Agree' }, { Value: 'I Do Not Agree' }]} />
                    </Row>
                  </div>
                </div>
              </div>
            </React.Fragment>
          </WizardBoxItem>
        )
      })

      agreementItems.push(
        <WizardBoxItem stepId={SignUpSteps.Confirm} icon="check" nextStepId={WizardBoxSteps.Done}
          previousStepId={(SignUpSteps.Agreements || []).length > 0 ? SignUpSteps.Agreements[SignUpSteps.Agreements.length - 1] : SignUpSteps.Password}>
          {this.renderConfirmationPage(formSubmit, loadingAccountAdd)}
        </WizardBoxItem>
      )
    }

    return (
      <FormBox form={formName} simpleBody initialValues={initialValues} onSubmit={this.onSubmit} onChange={this.onChange}>
        {SignUpSteps.Agreements && (data.GetCurrentRevisionsAgreementTemplatesResults || []).length > 0
          ? <WizardBox afterStepAction={this.afterStepAction} beforeStepAction={this.beforeStepAction} hideNextStepButton={false}
            defaultStepId={SignUpSteps.Email} noFinalStepButton>
            {agreementItems}
          </WizardBox>
          : null}
      </FormBox>
    )
  }
}

export const SignUp = compose(
  ReduxWrapper([
    sh.SessionToken,
    sh.FormData(formName, 'formDataSignUp'),
    sh.SessionAccount,
    sh.SessionDeviceFingerPrint
  ], [
    ah.sendToURL,
    ah.setAppState,
    ah.formCheckForSubmissionErrors,
    ah.formSetValidation,
    ah.setUser,
    ah.clearUser,
    ah.setAccount,
    ah.showInfo,
    ah.showWarning,
    ah.showError,
    ah.showSuccess,
    ah.formSubmit,
    ah.formSetFieldValue,
    ah.formStopSubmit
  ]),
  QueryWrapper({
    key: formName,
    actions: [
      {
        url: '/Services/Security/SignUp/ValidateEmail',
        prop: 'ValidateEmail',
        map: 'ValidateEmailResult'
      },
      {
        url: '/Services/Security/Shared/ValidateEmailCode',
        prop: 'ValidateEmailCode',
        map: 'ValidateEmailCodeResult'
      },
      {
        url: '/Services/Security/SignUp/ValidatePhone',
        prop: 'ValidatePhone',
        map: 'ValidatePhoneResult'
      },
      {
        url: '/Services/Security/Shared/ValidatePhoneCode',
        prop: 'ValidatePhoneCode',
        map: 'ValidatePhoneCodeResult'
      },
      {
        url: '/Services/Security/SignUp/ValidateUsername',
        prop: 'ValidateUsername',
        map: 'ValidateUsernameResult'
      },
      {
        url: '/Services/Security/SignUp/AccountAdd',
        prop: 'AccountAdd',
        map: 'AccountAddResult'
      },
      {
        url: '/Services/Security/Login',
        prop: 'AccountLogin',
        map: false
      },
      {
        url: '/Services/Support/AgreementTemplates/GetCurrentRevisions',
        prop: 'GetCurrentRevisionsAgreementTemplates',
        map: 'GetCurrentRevisionsAgreementTemplatesResults'
      },
      {
        url: '/Services/Data/Lookups/Get',
        prop: 'GetLookups',
        map: 'Lookups'
      }
    ]
  })
)(SignUpPlain)

export default SignUp
